"use client";

export default function EquationToolbar({
  onCopy,
  onClear,
  onSpeak,
  onStop,
  speaking,
}: {
  onCopy: () => void | Promise<void>;
  onClear: () => void;
  onSpeak: () => void | Promise<void>;
  onStop: () => void;
  speaking: boolean;
}) {
  return (
    <div className="no-drag flex items-center gap-2 mb-2">
      <button
        type="button"
        className="no-drag h-8 px-3 rounded-md bg-surface hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
        onClick={onCopy}
        aria-label="Copy LaTeX"
      >
        Copy LaTeX
      </button>
      <button
        type="button"
        className="no-drag h-8 px-3 rounded-md bg-surface hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
        onClick={onClear}
        aria-label="Clear"
      >
        Clear
      </button>
      <button
        type="button"
        className="no-drag h-8 px-3 rounded-md bg-surface hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
        onClick={onSpeak}
        aria-label="Speak equation"
      >
        {speaking ? "Speaking…" : "Speak"}
      </button>
      <button
        type="button"
        className="no-drag h-8 px-3 rounded-md bg-surface hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
        onClick={onStop}
        aria-label="Stop speaking"
        disabled={!speaking}
      >
        Stop
      </button>
    </div>
  );
}
